module.exports = __webpack_public_path__ + "static/media/icon-social-fb.7151eb9c.svg";